import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

import {Constants} from '../config/constants.config';

@Injectable()
export class CateringService {
    constructor(private readonly httpClient: HttpClient, private readonly constants: Constants) {
    }

    createCateringOrder(
        userId: string,
        diary_dates: string[],
        mealIds: number[],
        address: string,
        phone: string,
        note: string
    ): Observable<void> {
        return this.httpClient.post<void>(`${this.constants.apiURL()}/catering/diary/order/`, {
            'user_id': userId,
            'diary_dates': diary_dates,
            'meal_ids': mealIds,
            'address': address,
            'phone': phone,
            'note': note
        });
    }

}
